import { STATUS, ROLE, MAINTENANCE_UNIT } from 'types'
import type { OptionProps } from 'types'

export const DATE = {
  QUERY: 'dd-MM-yyyy',
  LOCAL_MONTH: 'dd LLL yy',
}

export const PRODUCT_LIMIT = 100

export const LIMIT_PAGE = 30

export const MICROSITE = 'Microsite'
export const FIXTAB_BFF = 'fixtab-bff'

export const STATUS_OPTIONS: OptionProps[] = [
  {
    key: STATUS.ALL,
    label: 'common:all.label',
  },
  {
    key: STATUS.ACTIVE,
    label: 'common:active.label',
  },
  {
    key: STATUS.IN_ACTIVE,
    label: 'common:inactive.label',
  },
]

export const ROLE_OPTIONS: OptionProps[] = [
  {
    key: '',
    label: 'common:all.label',
  },
  {
    key: ROLE.TECHNICIAN,
    label: 'staff:technician',
  },
  {
    key: ROLE.MANAGER,
    label: 'staff:manager',
  },
  {
    key: ROLE.SUPERVISOR,
    label: 'staff:supervisor',
  },
  {
    key: ROLE.ADMIN,
    label: 'staff:admin',
  },
]

export const MAINTENANCE_UNIT_OPTIONS: OptionProps[] = [
  {
    key: MAINTENANCE_UNIT.YEAR,
    label: 'common:year.label',
  },
  {
    key: MAINTENANCE_UNIT.MONTH,
    label: 'common:month.label',
  },
  {
    key: MAINTENANCE_UNIT.DAY,
    label: 'common:day.label',
  },
  {
    key: MAINTENANCE_UNIT.NONE,
    label: 'common:none.label',
  },
]

export enum WARRANTY {
  ACTIVE = 'warranty active',
  EXPIRES = 'warranty expires',
  NO_WARRANTY = 'no warranty',
}

export enum STATUSPROGRESS {
  DONE = 'done',
  IN_PROGRESS = 'in progress',
  NEW = 'new',
  PENDING = 'pending',
  REJECTED = 'rejected',
  CLOSED = 'closed',
  TRANSFERRING = 'transferring',
}

export const LIMIT = {
  PRICE: 13,
  PRODUCT_CATEGORY: 20,
}
